import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import { Typography, Button } from "@material-ui/core";
import GoogleIcon from "@mui/icons-material/Google";
import PhoneIcon from "@material-ui/icons/Phone";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import { ModalBottom } from "~/components/common/modalBottom/modalBottom";
import businessService from "~/services/businessService";
import businessAction from "~/store/actions/businessAction";
import BackgroundImage from "~/assets/images/image-bg-bussines-page.jpg";
import BadgeGoogle from "~/assets/icons/badges/get-in-googleplay.png";
import BadgeApple from "~/assets/icons/badges/get-in-applestore.svg";
import { useTranslation } from "react-i18next";
import { DialogBuilder } from "~/utils/DialogProvider";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import checkoutServices from "~/services/checkoutServices";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import { useResponsiveText } from "~/hooks/useResponsiveText";
import languageHelper from "~/helpers/language";
import _ from "lodash";
import useStyles from "./styles";
import WhatsAppLoginButton from "~/components/common/whatsappLogin";
import Utils from "~/helpers/Utils";
import { callWithSupport } from "~/utils/business";
import ModalUserName from "~/components/common/ModalUserName";
import { useWhatsAppAuthContext } from "~/contexts/WhatsAppAuthContext";

// De onde veio o login, pela rota de volta: define a resposta da validação no WhatsApp.
const getWhatsAppAuthContext = (route = "") => {
	if (route.includes("/later-payment/")) return "payment";
	if (route.includes("/checkout") || route.includes("/selecionar-") || route.includes("/packages/")) return "booking";
	return "login";
};

const BusinessPage = (props) => {
	const { linkReserveNotAuthorized, businessId } = props.location.state || {};
	const classes = useStyles();
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const provider = new GoogleAuthProvider();
	const auth = getAuth();

	const { id } = useParams();

	const meStore = useSelector((store) => store.me);
	const me = Utils.safeParseJSON("@prit-web/meData", meStore);
	const { user } = useSelector((store) => store.auth);
	const { business: businessFromStore } = useSelector((store) => store.business);
	const [business, setBusiness] = useState(businessFromStore || null);
	const [businessDdi, setBusinessDdi] = useState(null);
	const showLoginGoogle = !business ? false : business?.gmailClient;

	const currentUser = meStore?.me || user || {};
	const isOwnerUser =
		!_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser?.id === business?.ownerId;
	const dialog = useContext(DialogBuilder);

	const textSizes = useResponsiveText({ title: 30, subtitle: 22, button: 20 });

	const { authStatus, setAuthStatus, openModalCustom, setOpenModalCustom } = useWhatsAppAuthContext();
	const [loading, setLoading] = useState(false);
	const [whatsAppLoading, setWhatsAppLoading] = useState(false);
	const [showFallback, setShowFallback] = useState(false);
	const [showUserNameModal, setShowUserNameModal] = useState(false);

	useEffect(() => {
		if (openModalCustom === "REGISTER_NAME_USER" && _.isEmpty(me?.name)) {
			setShowUserNameModal(true);
		}
	}, [openModalCustom]);

	useEffect(() => {                                                                                                             
      if (!business?.language) return;                                                                                          
      if (business.language === "portuguese" || business.language === "portugal") {                                             
          i18n.changeLanguage("pt-BR");                                                                                         
      } else if (business.language === "spanish") {                                                                             
          i18n.changeLanguage("es-ES");                                                                                         
      } else if (business.language === "english") {                                                                             
          i18n.changeLanguage("en-US");                                                                                         
      }                                                                                                                         
  }, [business?.language]); 

	const loginWithGoogle = async () => {
		try {
			mixpanelTrackEvent("Fallback_Whatsapp_Google", {}, currentUser, isOwnerUser ? business : {});
			await signInWithPopup(auth, provider);

			const res = await checkoutServices.me();

			if (res?.data?.id) {
				localStorage.setItem("@prit-web/TypeLogin", JSON.stringify("Google"));
				localStorage.setItem("@prit-web/meData", JSON.stringify(res.data));
				localStorage.setItem("@prit-web/userId", res.data.id);
			}

			const goBackRoute = props.location.state?.goBackRoute || (id ? `/business/${id}` : `/business/link`);
			const goBackRouteProps = props.location.state?.goBackRouteProps || props.location.state;

			if (!res.data.phoneUnverified) {
				props.history.replace("/login/personal-information-number", {
					logEventFor: "Google",
					goBackRoute: goBackRoute,
					goBackRouteProps: goBackRouteProps,
				});
			} else {
				if (goBackRoute) {
					props.history.push(goBackRoute, goBackRouteProps);
				} else {
					window.location.reload();
				}
			}
		} catch (error) {
			alert(`Erro durante o login com Google: ${error.message}`);
		}
	};

	const fallBackLogin = () => {
		setShowFallback(true);
		mixpanelTrackEvent("Consumidor_com_dificuldades_no_Whatsapp", {}, currentUser, isOwnerUser ? business : {});
	};

	const handleSMSLogin = () => {
		mixpanelTrackEvent("Fallback_Whatsapp_Telefone", {}, currentUser, isOwnerUser ? business : {});
		// Usa o goBackRoute do state se disponível, caso contrário usa o padrão
		const goBackRoute = props.location.state?.goBackRoute || (business?.id ? `/business/${business?.id}` : (id ? `/business/${id}` : `/business/link`));
		const goBackRouteProps = props.location.state?.goBackRouteProps || props.location.state;

		localStorage.setItem("goBackRoute", JSON.stringify(goBackRoute));
		props.history.push(`/login`, {
			goBackRoute: goBackRoute,
			goBackRouteProps: goBackRouteProps,
		});
	};
 
	const loadBusiness = async () => {
		setLoading(true);
		await businessService
			.getBusiness(id)
			.then((res) => {
				dispatch(businessAction.setBusiness(res.data));
				setBusiness(res.data);
				setBusinessDdi(Utils.getCountryCodeFromPhone(res.data?.phone));
				let eventProps = {};
				if (!_.isEmpty(res.data?.language)) {
					eventProps = { Idioma: languageHelper.translate(res.data?.language) };
				}
				mixpanelTrackEvent("Clickou_Link_Business", eventProps, meStore?.me || {}, res.data || {});
				setLoading(false);
			})
			.catch((err) => {
				dialog
					.withMessage(err?.response?.data?.message)
					.withButtonText(t("Try again"))
					.withAction(() => {
						loadBusiness();
					})
					.show();
				setLoading(false);
			});
	};

	const handleScheduleReservationsClick = () => {
		if (meStore?.me?.name) {
			if (isOwnerUser) {
				mixpanelTrackEvent("Clicou_Link_Ver_Agendamentos", {}, currentUser, business);
			}
			props.history.push(`/reservas`);
		}
	};

	const goToFallback = () => {
		setShowFallback(true);
		setWhatsAppLoading(false);
		mixpanelTrackEvent("Fallback_Whatsapp_Google", {}, currentUser, isOwnerUser ? business : {});
	}

	useEffect(() => {
		if (!businessFromStore && id) {
			loadBusiness();
		} else {
			setBusinessDdi(Utils.getCountryCodeFromPhone(business?.phone));
		}
	}, []);

	if (linkReserveNotAuthorized) {
		const handleEnterReservations = () => {
			props.history.push(`/reservas`);
		};

		const handleScheduleAtEstablishment = () => {
			props.history.push(`/business/${businessId}`);
		};

		return (
			<>
			<TitleContainer 
				imageVisible={true} 
				imageCustom={BackgroundImage} 
				showGradient={false} 
				loading={loading}
				backgroundNew={true}
			>
				<div style={{ display: "flex", justifyContent: "center", alignItems: "end", marginBottom: 20, Maxheight: "100vh", minHeight: "40vh" }}>
						<div className={classes.badgesContainer}>
							<img src={BadgeGoogle} alt="Google Play" style={{ height: 40, paddingRight: 10 }} />
							<img src={BadgeApple} alt="App Store" style={{ height: 40 }} />
						</div>
				</div>
				<ModalBottom>
					<header className={classes.header}>
						<Typography className={classes.title} style={{ fontSize: textSizes.title }}>
							{t("Verify your access")}
						</Typography>
						<Typography
							className={classes.subtitle}
							style={{
								fontSize: textSizes.subtitle,
							}}>
							{t("This link is associated with another WhatsApp number. Enter the correct number or see your options below")}
						</Typography>
					</header>
					<div className={classes.buttonsContainer}>
						<Button
							disabled={false}
							onClick={handleEnterReservations}
							className={classes.button}
							style={{ 
								fontSize: textSizes.button,
								border: "1px solid rgba(0,0,0,0.3)",
								backgroundColor: "white",
								color: "black"
							}}>
							<span style={{ flexGrow: 1, textAlign: "center" }}>
								{t("Go to my reservations")}
							</span>
						</Button>
						<Button
							disabled={false}
							onClick={handleScheduleAtEstablishment}
							className={classes.button}
							style={{ 
								fontSize: textSizes.button,
								border: "1px solid rgba(0,0,0,0.3)",
								backgroundColor: "white",
								color: "black"
							}}>
							<span style={{ flexGrow: 1, textAlign: "center" }}>
								{t("Schedule at establishment")}
							</span>
						</Button>
					</div>
					<Typography
						style={{
							fontSize: "clamp(12px, 1.2vw, 14px)",
							color: "rgba(0,0,0,0.6)",
							textAlign: "center",
							marginTop: "16px",
							padding: "0 16px"
						}}>
						O link é válido, mas está associado a outro numero
					</Typography>
				</ModalBottom>
			</TitleContainer>
		</>
		);
	}

	const successRoute = props.location.state?.goBackRoute || `/reservas`;
	const afterNameUpdateRoute = props.location.state?.afterNameUpdateRoute || successRoute;

	return (
		<>
			<ModalUserName
				open={showUserNameModal}
				onClose={() => {
					setShowUserNameModal(false);
					setAuthStatus(null);
					if (openModalCustom === "REGISTER_NAME_USER") {
						setOpenModalCustom(false);
						props.history.push(afterNameUpdateRoute);
					}				
				}}
			/>
			<TitleContainer
				imageVisible={true}
				imageCustom={BackgroundImage}
				showGradient={false}
				loading={loading}
				backgroundNew={true}
			>
				<div style={{ display: "flex", justifyContent: "center", alignItems: "end", marginBottom: 20, Maxheight: "100vh", minHeight: "40vh" }}>
						<div className={classes.badgesContainer}>
							<img src={BadgeGoogle} alt="Google Play" style={{ height: 40, paddingRight: 10 }} />
							<img src={BadgeApple} alt="App Store" style={{ height: 40 }} />
						</div>
				</div>
				<ModalBottom>
					<header className={classes.header} onClick={handleScheduleReservationsClick}>
						<Typography className={classes.title} style={{ fontSize: textSizes.title }}>
							{business?.name ? t("Client of", { businessName: business?.name }) : t("Access your account")}
						</Typography>
						<Typography
							className={classes.subtitle}
							style={{
								fontSize: textSizes.subtitle,
								textDecoration: `${!meStore?.me?.name ? "" : "underline"}`,
							}}>
							{business?.name ? t("Check your appointments, rewards, and notifications here") : t("Sign in to see your appointments rewards and important notices")}
						</Typography>
					</header>
					<div className={classes.buttonsContainer} style={{ position: "relative" }}>
						{whatsAppLoading && (
							<div
								style={{
									position: "absolute",
									top: 0,
									left: 0,
									right: 0,
									bottom: 0,
									backgroundColor: "rgba(255, 255, 255, 0.7)",
									zIndex: 10,
									borderRadius: "8px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							/>
						)}
							<>
								{showFallback ? (
									<>
										<Typography style={{ padding: "0 20px 20px 20px", fontSize: 14, textAlign: "center" }}>
											{t("whatsappLoginPhoneConfirmationMessage")}
										</Typography>
										{(process.env.REACT_APP_GOOGLE_LOGIN_ENABLED === "true" && showLoginGoogle) && (
											<Button
												disabled={whatsAppLoading}
												onClick={loginWithGoogle}
												className={classes.button}
												style={{ 
													fontSize: textSizes.button, 
													opacity: whatsAppLoading ? 0.5 : 1,
													border: "1px solid rgba(0,0,0,0.3)",
													textTransform: "uppercase",
													fontWeight: "Bold",
													marginBottom: "5%",
													backgroundColor: "transparent",
													color: "#222"
												}}>
												<GoogleIcon className={classes.icon} />
												<span style={{ flexGrow: 1, textAlign: "center" }}>{t("Continue Google")}</span>
											</Button>
										)}
										<Button
											disabled={whatsAppLoading}
											onClick={handleSMSLogin}
											className={classes.button}
											style={{ 
												fontSize: textSizes.button, 
												opacity: whatsAppLoading ? 0.5 : 1,
												textTransform: "uppercase",
												fontWeight: "Bold",
												backgroundColor: "transparent",
												color: "#222",
												border: "1px solid #222"
											}}>
											<PhoneIcon className={classes.icon} />
											<span style={{ flexGrow: 1, textAlign: "center" }}>
												{t("Continue")}
											</span>
										</Button>
										<div style={{ paddingBottom: 15, display: "flex", justifyContent: "center", alignItems: "center" }}>
											<Typography onClick={() => callWithSupport(t("whatsappSupportLoginMessage"), t)} style={{ 
												fontSize: "clamp(14px, 1vw, 16px)", 
												textAlign: "center", 
												color: "#666666", 
												marginTop: 10, 
												textDecoration: "underline", 
												width: "90%",
												cursor: "pointer"
											}}
											>
												{t("whatsappLoginSupportMessage")}
											</Typography>
										</div>
									</>
								) : (
									<>
										<WhatsAppLoginButton
											successRoute={props.location.state?.goBackRoute || `/reservas`}
											authContext={getWhatsAppAuthContext(props.location.state?.goBackRoute)}
											business={business}
											language={i18n?.language || "pt-BR"}
											onLoadingChange={setWhatsAppLoading}
											style={{ 
												fontSize: textSizes.button, 
												opacity: whatsAppLoading ? 0.5 : 1,
												textTransform: "uppercase",
												fontWeight: "Bold",
												marginBottom: "5%",
												border: "none",
												height: 44,
												backgroundColor: "#672E37",
												color: "#fff"
											}}
											label={t("Enter with WhatsApp")}
											goToFallbackBusinessPage={goToFallback}
										/>
										<div style={{ paddingBottom: 15, display: "flex", justifyContent: "center", alignItems: "center" }}>
											<Typography onClick={() => fallBackLogin()} style={{ 
												fontSize: "clamp(14px, 1vw, 16px)", 
												textAlign: "center", 
												color: "#666666", 
												marginTop: 10, 
												textDecoration: "underline", 
												width: "90%",
												cursor: "pointer"
											}}
											>
												{t("whatsappLoginDifficultyMessage")}
											</Typography>
										</div>
									</>
								)}
							</>
					</div>
				</ModalBottom>
			</TitleContainer>
		</>
	);
};

export default withRouter(BusinessPage);
